// styles.js
export const sxStyle = {
  card: {
    borderRadius: 2,
    mb: 1,
    bgcolor: '#F3F3F3',
    height: 'auto',
  },
  headerBox: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    p: 1,
  },
  airlineGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  airlineLogo: {
    width: { xs: 20, sm: 25, md: 30 },
    height: { xs: 20, sm: 25, md: 30 },
  },
  labelText: { fontSize: { xs: 13, sm: 15 } },
  valueText: {
    fontSize: { xs: 12, sm: 14 },
    fontWeight: 600,
    lineHeight: { xs: 1.2, sm: 1.5 },
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  dividerVertical: { bgcolor: 'darkgray', m: 0 },
  dividerHorizontal: { width: '95%', bgcolor: 'darkgray' },
  timeLocationText: { fontSize: { xs: 12, sm: 14 }, fontWeight: 600 },
  locationText: {
    fontSize: { xs: 12, sm: 14 },
    fontWeight: 600,
    color: 'rgb(102,104,105)',
  },
  operatedBox: {
    display: 'flex',
    justifyContent: 'center',
    p: 1,
    textAlign: 'center',
  },
  operatedText: {
    fontSize: { xs: 13, sm: 14 },
    fontWeight: 600,
    color: '#000',
  },
};
